import type { BffLogicalDeviceResourceReadApi } from '@ingenico/api-sdk-provisioning-private';
import {
  useBusinessServiceRequest,
  useBusinessServiceRequestWithFirstQueryLoading,
} from '@ingenico/react-section-utils';
import type { ReactElement } from 'react';
import { useCallback } from 'react';
import { DeviceManagementService } from '../../../domain/business/services/deviceManagement.service';
import type { DeviceManagementLogicalDeviceAttachedDevicePanelProps } from '../../../domain/models/logicalDeviceAttachedDevicePanel.model';
import { LogicalDeviceInfoAttached } from './logicalDeviceInfoAttached.ctrl';

export function LogicalDeviceInfoAttachedPanel({
  logicalDeviceId,
  isSuspended,
  isEnabledSwap,
  isErrorSwapStatus,
  onRefreshLogicalDeviceDetails,
  onRightColumnExtensionContainerReady,
}: DeviceManagementLogicalDeviceAttachedDevicePanelProps): ReactElement {
  const logicalDeviceDetailsQuery = useBusinessServiceRequest(
    DeviceManagementService,
    useCallback(
      (deviceManagementService) => deviceManagementService.getLogicalDeviceDetailsBff(logicalDeviceId),
      [logicalDeviceId],
    ),
  );

  const deviceIdV2 = useBusinessServiceRequestWithFirstQueryLoading(
    DeviceManagementService,
    useCallback(
      (deviceManagementService) =>
        logicalDeviceId ? deviceManagementService.getDeviceIdV2({ deviceId: logicalDeviceId }) : null,
      [logicalDeviceId],
    ),
  );

  const logicalDeviceDetailsQueryWithRefresh = {
    ...logicalDeviceDetailsQuery,
    refetch: () => {
      logicalDeviceDetailsQuery.refetch();
      onRefreshLogicalDeviceDetails?.();
    },
  } as typeof logicalDeviceDetailsQuery & { readonly data?: BffLogicalDeviceResourceReadApi };

  return (
    <LogicalDeviceInfoAttached
      deviceIdV2={deviceIdV2}
      isEnabledSwap={Boolean(isEnabledSwap)}
      isErrorSwapStatus={Boolean(isErrorSwapStatus)}
      isSuspended={Boolean(isSuspended)}
      logicalDeviceDetailsQuery={logicalDeviceDetailsQueryWithRefresh}
      logicalDeviceId={logicalDeviceId}
      onRightColumnExtensionContainerReady={onRightColumnExtensionContainerReady}
    />
  );
}
